<div *ngIf="parentPage != 'filter_modal'">
    <div class="full_div">
        <div class="loader-container">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p id="loading-message" class="message">{{ showMessage }}</p>
        </div>
    </div>
</div>

<div *ngIf="parentPage == 'filter_modal'">
    <div class="modal_div">
        <div class="loader-container">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p id="loading-message" class="message">{{ showMessage }}</p>
        </div>
    </div>
</div>
